export const VIP_FAN_SECTOR_REGEX = /\bvip\s*[-_ ]?\s*fan\b/i;
export const LODGE_HOVER_STROKE = '#459cdeff';
export const LODGE_DEFAULT_FILL = '#f1f1ec';
export const LODGE_PRICE_HIGHLIGHT_COLOR = '#8CCEFF';
export const LODGE_MARKER_COLOR = '#459CDE';
export const LODGE_MARKER_RADIUS = 42;
export const LODGE_MARKER_GLOW_LAYERS = [
  { radiusMultiplier: 1.8, opacity: 0.06 },
  { radiusMultiplier: 1.5, opacity: 0.12 },
  { radiusMultiplier: 1.2, opacity: 0.22 },
] as const;
export const LODGE_PRICE_HIGHLIGHT_FILL_OPACITY = 0.18;
export const LODGE_AVAILABLE_STROKE_WIDTH = 2.5;
export const LODGE_PRICE_GLOW_LAYERS = [
  { strokeWidthMultiplier: 6, opacity: 0.06 },
  { strokeWidthMultiplier: 4, opacity: 0.12 },
  { strokeWidthMultiplier: 2.5, opacity: 0.2 },
] as const;
export const ACTIVE_SECTOR_STROKE = '#007AFF';
export const PIXI_SECTOR_STROKE_SCALE = 5;
export const PIXI_LODGE_STROKE_SCALE = 18;
export const MOBILE_NEAREST_SEAT_RADIUS = 30;
export const SEAT_TAP_INDEX_CELL_SIZE = 64;
export const MOBILE_STAGE_HEIGHT = 600;
export const DESKTOP_STAGE_MAX_HEIGHT = 900;
export const DESKTOP_ZOOM_CONTROLS_WIDTH = 64;
export const DESKTOP_ZOOM_CONTROLS_MAX_TOP_PX = 200;
export const ZOOM_CONTROLS_HALF_STACK_HEIGHT_PX = 46;
export const SEAT_MAP_MAX_SCALE = 2;
export const SEAT_MAP_CLOCKWISE_ROTATION_DEG = 90;
export const DEFAULT_SEAT_MAP_EDGE_PADDING_PX = { mobile: 32, desktop: 48 } as const;

// Добавляйте сюда showId мероприятий, схемы которых нужно дополнительно повернуть вправо.
export const SEAT_MAP_CLOCKWISE_ROTATION_SHOW_IDS: readonly number[] = [3603];
